import React, { createContext, useState, useCallback, useContext } from 'react';

/**
 * Header state shared with the views.
 *
 * The header search itself is **not** part of this any more: it always searches
 * bookings and vouchers and can no longer be taken over by a view. A view that
 * needs to filter its own data renders its own search field.
 */
const HeaderContext = createContext({
  customActions: null,
  registerActions: actions => {},
  unregisterActions: () => {},
});

export const HeaderProvider = ({ children }) => {
  const [customActions, setCustomActions] = useState(null);

  const registerActions = useCallback(actions => {
    setCustomActions(actions);
  }, []);

  const unregisterActions = useCallback(() => {
    setCustomActions(null);
  }, []);

  const value = {
    customActions,
    registerActions,
    unregisterActions,
  };

  return <HeaderContext.Provider value={value}>{children}</HeaderContext.Provider>;
};

export const useHeader = () => {
  return useContext(HeaderContext);
};

export default HeaderContext;
